const { CLIENT_ID, ISSUER } = process.env

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: window.location.origin + '/storyfinder/oktasuccess',
    scopes: ['openid', 'profile']
  },
  fetchSecApi: 'https://56bxw0zcj2.execute-api.us-east-1.amazonaws.com/prod/fetch-secret',
  automationConfigUrl: 'https://editorialapps.meredith.com/Automation_Config/',
  lambdaUrl: 'https://s4q3ulhpwg.execute-api.us-east-1.amazonaws.com/prod',
  imageTokenUrl: 'https://editorialapps.meredith.com/assetsImageToken',
  secAutoConfigName: 'automation_config_bearer',
  secImgTokenName: 'image_token_bearer'
}
